import React from 'react';
import './RadioGroup.css';

const RadioGroup = ({ index, status }) => {
	const radioItems = [
		{ id: 'radio1', label: 'Tjänsteledig' },
		{ id: 'radio2', label: 'Semester' },
		{ id: 'radio3', label: 'Hemma' },
	];

	return (
		<div className="radio-container">
			{radioItems.map((radio, idx) => (
				<div className="custom-radio" key={radio.id}>
					<input
						type="checkbox"
						id={radio.id}
						name={`radio-group-${index}`}
						checked={status.toLowerCase() === radio.label.toLowerCase()}
					/>
					<label
						htmlFor={radio.id}
						style={{ display: index === 0 && idx < 3 ? 'block' : 'none' }}
					>
						{radio.label}
					</label>
				</div>
			))}
		</div>
	);
};

export default RadioGroup;
